import { Container, Sprite } from 'pixi.js';
import type { TrayState } from '../boardMVC/types';
import type { BoardViewFactory } from '../boardMVC/views/board/BoardViewFactory';
import { TileStackModel } from '../boardMVC/models/board/TileStackModel';
import { TileModel } from '../boardMVC/models/board/TileModel';

export class SolverTrayView extends Container {
  constructor(viewFactory: BoardViewFactory, trayState: TrayState, moveIndex: number) {
    super();

    trayState.colors.slice(0, 3).forEach((colors, index) => {
      const model = new TileStackModel(0, 0);
      colors.forEach((color) => {
        model.addTiles(new TileModel(color));
      });
      viewFactory.createStackView(model).props({
        parent: this,
        x: index * 150,
      });

      if (moveIndex === index) {
        new Sprite().props({
          parent: this,
          x: index * 150,
          texture: 'tile_hover',
          anchor: 0.5,
        });
      }
    });
  }
}
